import { render, staticRenderFns } from "./PdfViewerTemplate.vue?vue&type=template&id=b65879a2&scoped=true&lang=pug&"
import script from "./PdfViewerTemplate.vue?vue&type=script&lang=ts&"
export * from "./PdfViewerTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./PdfViewerTemplate.vue?vue&type=style&index=0&id=b65879a2&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65879a2",
  null
  
)

export default component.exports